import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class TagsProvider extends HttpRequest {
  async getAllTags () {
    this.setHeader(getAuthToken())
    return this.fetch('/tagProducts')
  }
}

export default TagsProvider
